import React from 'react';
import { Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Brand({ to = '/', subtitle = null, size = 'md', className = '' }) {
  const dim = size === 'lg' ? 44 : size === 'sm' ? 28 : 36;
  const iconSize = size === 'lg' ? 22 : size === 'sm' ? 14 : 18;
  return (
    <Link to={to} className={`flex items-center gap-3 group ${className}`}>
      <span
        className="inline-flex items-center justify-center rounded-full border border-gold/40 bg-gold/10 transition-all group-hover:bg-gold/20 group-hover:border-gold/60"
        style={{ width: dim, height: dim }}
      >
        <Sparkles size={iconSize} className="text-gold" />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="font-serif text-white tracking-tight" style={{ fontSize: size === 'lg' ? 22 : size === 'sm' ? 14 : 17 }}>
          The Elemental Embrace
        </span>
        {subtitle && (
          <span className="text-[11px] tracking-[0.18em] uppercase text-gold/80">{subtitle}</span>
        )}
      </span>
    </Link>
  );
}
